<template>
  <div v-if="showRangeBar" class="cdb-range-scale">
    <h2 class="font-weight-bold text-success text-center mb-0">
      {{ rangeString }}
    </h2>
    <h6 class="font-weight-light text-light text-center">
      {{ predominateCanabinoid ? predominateCanabinoid.abbreviation + " " + "Range" : "CBD Range" }}
    </h6>
    <div v-if="showRangeBar" class="cbd-range-slider-wrapper">
      <div id="cbd_slider_range_bar" class="cbd-slider-range-bar" />
      <div :style="'left:' + rangeBarStart + '%; width:' + rangeBarWidth + '%'" class="cbd-slider-range-bar-status" />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    batch: { type: Object, required: true },
    category: { type: Object, required: true },
    predominateCanabinoid: { type: Object, default: null },
  },
  data() {
    return {
      rangeString: null,
      showRangeBar: false,
      rangeBarStart: null,
      rangeBarWidth: null,
    };
  },
  computed: {},
  watch: {
    batch(oldVal, newVal) {
      if (oldVal != newVal) {
        this.setupSlider();
      }
    },
  },
  mounted() {
    this.setupSlider();
  },
  methods: {
    setupSlider() {
      // const val = calculateProductCbdDisplay(this.batches, this.category.name, true);
      // rangeString: value,
      // isUsingPercentage: isPercentage,
      // minValue: startingNumber,
      // maxValue: endingNumber,
      //
      this.showRangeBar =
        this.batch.predominate_canabinoid_unit == "%" &&
        this.batch.predominate_canabinoid_min_or_only &&
        Number(this.batch.predominate_canabinoid_min_or_only) > 0;
      this.rangeString = `${this.batch.predominate_canabinoid_min_or_only} ${
        this.batch.predominate_canabinoid_max ? ` - ${this.batch.predominate_canabinoid_max}` : ""
      } ${this.batch.predominate_canabinoid_unit}`;
      this.rangeBarStart = this.batch.predominate_canabinoid_min_or_only;
      this.rangeBarWidth = 5;
      if (this.batch.predominate_canabinoid_max) {
        this.rangeBarWidth = this.batch.predominate_canabinoid_max - this.batch.predominate_canabinoid_min_or_only;
      }
    },
  },
};
</script>
